// Adapted from normalize.css v2.1.2 | MIT License | git.io/normalize
body { margin: 0 }
a { background: transparent; color: inherit }
a:active, a:hover { outline: 0 }
b, strong { font-weight: bold }
hr { height: 0 }
code, kbd, pre, samp { font-family: Consolas , Monaco, monospace, serif }
pre { white-space: pre-wrap }
q { quotes: "\201C" "\201D" "\2018" "\2019" }
small { font-size: 80% }
sub, sup { font-size: 75%; line-height: 0; position: relative; vertical-align: baseline; }
sup { top: -0.5em }
sub { bottom: -0.25em }
img { border: 0 }
figure { margin: 0 }
svg:not(:root) { overflow: hidden }
button, input, select, textarea { font-family: inherit; font-size: 100%; margin: 0; }
button, input { line-height: normal }
form { margin: 0 }
input { border: 0; outline: 0; }
textarea { background-color: transparent; border: 0; max-width: 100%; outline: 0; width: 100%; }
fieldset, legend { margin: 0; padding: 0; border: 0; }
button, html input[type="button"], input[type="reset"], input[type="submit"] {-webkit-appearance: none;cursor: pointer;border: 0;outline: 0;}
button[disabled], html input[disabled] { cursor: default }
input[type="search"] { -webkit-appearance: textfield }
input[type="search"]::-webkit-search-cancel-button, input[type="search"]::-webkit-search-decoration { -webkit-appearance: none;}
button::-moz-focus-inner, input::-moz-focus-inner { border: 0; padding: 0; }
textarea { overflow: auto; }
html, html a { -webkit-font-smoothing: antialiased; text-shadow: 1px 1px 1px rgba(0,0,0,0.004); }
* { box-sizing: border-box; -webkit-box-sizing: border-box; -moz-box-sizing: border-box; }
